"use client";
import Image from "next/image";

export default function ArticleImage({ src, alt = "" }) {
    if (!src) return null;

    return (
        <figure className="group">
            <div className="relative w-full overflow-hidden rounded-2xl ">
                <Image
                    src={src}
                    alt={alt}
                    width={1024} // match your actual image dimensions
                    height={1536}
                    className="object-cover max-h-75vh w-auto mx-auto transition-transform duration-300 group-hover:scale-[1.02]"
                    sizes="
                        (max-width: 640px) 100vw,
                        (max-width: 1024px) 92vw,
                        1024px
                    "
                    priority
                    fetchPriority="high"
                />
            </div>

            {alt ? (
                <figcaption className="mt-2 text-center text-xs sm:text-sm text-gray-500 italic">
                    {alt}
                </figcaption>
            ) : null}
        </figure>
    );
}
